(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('MessaggioVoucherDialogController', MessaggioVoucherDialogController);

    MessaggioVoucherDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'MessaggioVoucher', 'VisioneConsenso'];

    function MessaggioVoucherDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, MessaggioVoucher, VisioneConsenso) {
        var vm = this;

        vm.messaggioVoucher = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.visioneconsensos = VisioneConsenso.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.messaggioVoucher.id !== null) {
                MessaggioVoucher.update(vm.messaggioVoucher, onSaveSuccess, onSaveError);
            } else {
                MessaggioVoucher.save(vm.messaggioVoucher, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consinfApp:messaggioVoucherUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.requestDate = false;
        vm.datePickerOpenStatus.sendDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
